// extracted by mini-css-extract-plugin
module.exports = {"root":"j_bj","item":"j_1","item-img":"j_bk","itemImg":"j_bk","grid-item-title":"j_bl","gridItemTitle":"j_bl"};